import React, { FC } from "react"
import styled from "@emotion/styled"
import scrollTo from "gatsby-plugin-smoothscroll"
import { useTranslation } from "react-i18next"
import Box from "@/components/Box"

const Wrapper = styled.div`
  width: 100%;
  height: 480px;
  padding: 145px 24px 132px;

  @media screen and (min-width: 1024px) {
    height: 832px;
    padding: 345px 24px 288px;
  }
`

const Header = styled.h1`
  font-weight: 600;
  font-size: 48px;
  line-height: 115%;
  text-align: center;
  letter-spacing: -0.015em;
  color: #f4f4f4;
  margin-bottom: 38px;

  @media screen and (min-width: 1024px) {
    font-size: 74px;
    margin-bottom: 56px;
  }
`

const ExploreBtn = styled.button`
  border: none;
  display: block;
  margin: 0 auto;
  width: auto;
  padding: 19px 32px;
  background: #f4f4f4;
  box-shadow: 0px 10px 20px rgba(19, 53, 100, 0.1);
  border-radius: 4px;
  font-weight: 600;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: 0.02em;
  color: #133564;
  white-space: nowrap;
`

const Container = styled(Box)`
  width: 100%;
  height: 482px;
  background-position: center center;
  background-repeat: repeat-y;
  background-size: cover;
  background-image: url(${process.env
    .ASSETS_BASE_URL}/careers-page/top-background.webp);
  background-color: #0d1b2a;
  @media screen and (min-width: 1024px) {
    height: 832px;
  }
`

const Hero: FC = () => {
  const { t } = useTranslation("careers")

  return (
    <Container>
      <Wrapper>
        <Header>{t("hero.title")}</Header>
        <ExploreBtn onClick={() => scrollTo("#jobs")}>
          {t("hero.cta")}
        </ExploreBtn>
      </Wrapper>
    </Container>
  )
}

export default Hero
